module.exports = __webpack_public_path__ + "img/sabbatical-beauty_banner.14682f87.jpg";